import { Box, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { SharedModal } from 'components/shared/Modal';

type FullViewDiagramModalProps = {
	handleCloseModal: () => void;
};

export const WorkInProgressModal: FC<FullViewDiagramModalProps> = ({ handleCloseModal }) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	const [open, setOpen] = useState<boolean>(true);

	const handleClose = () => {
		handleCloseModal();
		setOpen(false);
	};

	return (
		<SharedModal isOpen={open} handleClose={handleClose}>
			<Box
				sx={{
					textAlign: 'center',
					display: 'flex',
					flexDirection: 'column',
					gap: { xs: '16px', sm: '32px' },
				}}
			>
				<Typography
					variant="h3"
					sx={{ fontSize: '24px', fontWeight: '700', marginTop: { xs: '16px', sm: '32px' } }}
				>
					{modalTranslate('upcomingFeatureModal.title')}
				</Typography>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
					}}
				>
					<Typography sx={{ color: '#9FA6B3', marginTop: '8px', textAlign: 'center' }}>
						{modalTranslate('upcomingFeatureModal.description')}
					</Typography>
				</Box>
			</Box>
		</SharedModal>
	);
};
